
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

export const OtherRestaurantsSlider = () => {
  const $sliderWrapper = $('.js-otherRestaurants__slider');
  if ( !$sliderWrapper.length ) {
      return
  }

  $(document).ready(function() {
    new Swiper('.js-otherRestaurants__slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.js-otherRestaurants__pagination',
        clickable: true,
      },
  
      // Navigation arrows
      navigation: {
        nextEl: '.js-otherRestaurants__nextSlide',
        prevEl: '.js-otherRestaurants__prevSlide',
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    })
  
  });
}